import './AgentScoreGauge.scss'

import React, {Component} from 'react'
import { METRIC_RANK_SCORE_BARRIERS, METRIC_SCORE_MIN, METRIC_SCORE_MAX } from 'common/constants'
import { getRankForScore } from 'common/util/metrics_helper'

const [
  RANK0_LOWER_BOUND,
  RANK1_LOWER_BOUND,
  RANK2_LOWER_BOUND,
  RANK3_LOWER_BOUND,
] = METRIC_RANK_SCORE_BARRIERS

const projectRotationForScore = (minDeg, maxDeg, minScore, maxScore) => score => {
  const ratio = (score - minScore) / (maxScore - minScore)
  const range = maxDeg - minDeg
  return Math.round(Math.abs(ratio * range) + minDeg)
}

const projectorsByRank = [
  projectRotationForScore(110, 120, RANK0_LOWER_BOUND, METRIC_SCORE_MAX),
  projectRotationForScore(70, 110, RANK1_LOWER_BOUND, RANK0_LOWER_BOUND - 1),
  projectRotationForScore(-70, 70, RANK2_LOWER_BOUND, RANK1_LOWER_BOUND - 1),
  projectRotationForScore(-110, -70, RANK3_LOWER_BOUND, RANK2_LOWER_BOUND - 1),
  projectRotationForScore(-120, -110, METRIC_SCORE_MIN, RANK3_LOWER_BOUND - 1),
]

const needleStylesByRank = [
  'dark-green',
  'green',
  'pale-green',
  'yellow',
  'orange'
]

export class Needle extends Component {

  state = {
    rotation: this.props.startingRotation || 0
  }

  componentDidMount() {
    const { score } = this.props
    const toValue = projectorsByRank[getRankForScore(score)](score)
    this.setState({rotation: toValue})
  }

  render() {
    const { score } = this.props
    const { rotation } = this.state

    const style = needleStylesByRank[getRankForScore(score)]

    return (
      <div className="AgentScoreGauge__needle-container" style={{transform: `rotate(${rotation}deg)`}}>
        { score && <div className={`AgentScoreGauge__needle--${style}`}/> }
      </div>
    )
  }
}

const Gauge = ({ children }) => {
  return (
    <div className="AgentScoreGauge__wrapper">
      <div className="AgentScoreGauge__multicolor"/>
      { children }
    </div>
  )
}

export const AgentScoreGauge = ({ score, startingRotation }) => (
  <div className="AgentScoreGauge">
    <div className="AgentScoreGauge__score">{ score || '-' }</div>
    <Gauge>
      <Needle score={score} startingRotation={startingRotation}/>
    </Gauge>
    <div className="AgentScoreGauge__left-text">80</div>
    <div className="AgentScoreGauge__right-text">120</div>
    <div className="AgentScoreGauge__title">Opcity score</div>
  </div>
)